<template>
  <div class="homeBox">
    <!--    banner     -->
    <div class="banner PurchaseBanner">
      <img src="../../public/img/ebg.png" alt="">
      <div class="softScript PurchaseSoftScript">
        <div class="TipText">
          <div class="title">企业设置</div>
          <div class="line">
            <span class="blue"></span>
            <span class="yellow"></span>
            <span class="green"></span>
          </div>
          <div class="script">
            设置企业信息，配置企业机构，给高层、中层人员分解工作内容，<br/>不同的人有不同的权限，
            做到提高工作效率、缩短工作流程，<br/>使上下级工作线流程清晰。
          </div>
          <div class="start">
            <a href="javascript:;" onclick="window.open('http://www.teamrobotics.net/project')">
              开始吧
              <img src="../../public/img/right.png" alt="">
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="SolveQuestion PurchaseQuestion">
      <div class="w1200">
        <div class="clearfix Sales">
          <div class="l">
            <img src="../../public/img/e1.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/eicon1.png" alt="">
            </div>
            <div class="tip">
              基本信息
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      建立企业人员信息
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="clearfix Progress">
          <div class="l">
            <img src="../../public/img/e2.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/eicon2.png" alt="">
            </div>
            <div class="tip">
              机构配置
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      建立企业机构，划分员工所属部门，便于管理
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="clearfix Purchase">
          <div class="l">
            <img src="../../public/img/e3.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/eicon3.png" alt="">
            </div>
            <div class="tip">
              标签管理
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      根据员工所属部门、职位，设置系统内可操作的菜单项
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="clearfix Progress GetMetarial">
          <div class="l">
            <img src="../../public/img/e4.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/eicon4.png" alt="">
            </div>
            <div class="tip">
              成员管理
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      建立企业内部所有成员资料
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="clearfix Purchase">
          <div class="l">
            <img src="../../public/img/e5.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/eicon5.png" alt="">
            </div>
            <div class="tip">
              角色管理
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      创建企业角色、配置相关权限
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="clearfix Progress GetMetarial">
          <div class="l">
            <img src="../../public/img/e6.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/eicon6.png" alt="">
            </div>
            <div class="tip">
              审批流程
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      对企业成员发出各类申请的审批流程进行配置
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="clearfix Purchase">
          <div class="l">
            <img src="../../public/img/e7.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/eicon7.png" alt="">
            </div>
            <div class="tip">
              消息通知
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      通知审批人员处理各类申请、采购需求。
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--提高效率，提高竞争力-->
    <div class="Increase PurchaseIncrease">
      <div class="w1200">
        <div class="TipText">
          <div class="title">提高效率，提高竞争力</div>
          <div class="line">
            <span class="blue"></span>
            <span class="yellow"></span>
            <span class="green"></span>
          </div>
          <div class="script">
            让每个自动化企业都享受智慧服务与数据
            带来的改变
            <div class="bottomStart"><a href="javascript:;" onclick="window.open('http://www.teamrobotics.net/project')">开始吧<img src="../../public/img/right.png" alt=""></a></div>
          </div>
        </div>
      </div>
    </div>
    <!--导航  pc+mobile-->
    <Nav></Nav>
    <!--底部-->
    <Foot></Foot>
    <!--返回头部-->
    <GoTop></GoTop>
  </div>
</template>
<script>
  import Nav from '@/components/Nav.vue'
  import GoTop from '@/components/GoTop.vue'
  import Foot from '@/components/Foot.vue'
  export default {
    name: 'CompanySetting',
    data(){
      return {

      }
    },
    components: {
      Nav,
      GoTop,
      Foot
    },
    computed:{

    },
    methods:{

    },
    mounted(){

    },
    activated(){

    },
    created(){

    }
  }
</script>
<style>

</style>
